import { render, staticRenderFns } from "./BetTypeSelectorMarketView.vue?vue&type=template&id=2b4e0ddb&scoped=true"
import script from "./BetTypeSelectorMarketView.vue?vue&type=script&lang=js"
export * from "./BetTypeSelectorMarketView.vue?vue&type=script&lang=js"
import style0 from "./BetTypeSelectorMarketView.vue?vue&type=style&index=0&id=2b4e0ddb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4e0ddb",
  null
  
)

export default component.exports